import React from "react";
import "./Codes.css";

import SamaListView from "../SamaListView";
import Button from "../Button";

import Input from "../InputText";

import ProgressBar from "react-bootstrap/ProgressBar";

function defaultClick(e) {
  e.preventDefault();
}

function ActivityCodeList10(props) {
  let {
    Items,
    inputStyle,
    event,
     listName,
      inputId,
      addNewCode,

    section,
    BtnActive,

    ActivitySuggestions,
    onChange,
    onClick,
    placeholder,

    userInputActivity,
    activeSuggestion,

    filteredSuggestionsActivity,
    showActivitySuggestions,
    handleItemDeletion,
    ActivityNow,
  } = props;

  let suggestionsListComponentActivity;

  if (showActivitySuggestions && userInputActivity) {
    if (filteredSuggestionsActivity && filteredSuggestionsActivity.length) {
      suggestionsListComponentActivity = (
        <ul className="suggestions">
          {filteredSuggestionsActivity.map((suggestion, index) => {
            let className;

            // Flag the active suggestion with a class
            if (index === activeSuggestion) {
              className = "suggestion-active";
            }

            return (
              <li className={className} key={suggestion} onClick={onClick}>
                {suggestion}
              </li>
            );
          })}
        </ul>
      );
    } else {
      suggestionsListComponentActivity = (
        <div className="no-suggestions">
          <em>No suggestions...</em>
        </div>
      );
    }
  }

  let InputId = "",
    BtnValue = "";
  if (listName === "ActivityCodes") {
    InputId = "activityCode";
    BtnValue = "Confirm Code";
  }

  return (
    <React.Fragment>
      {Items && Items.length > 0 ? (
        <SamaListView
          Items={Items}
          name="codes"
          handleItemDeletion={handleItemDeletion}
          listName={listName}
        />
      ) : null}

      <div>
        {/* {
          //!suggestions
          ActivitySuggestions && ActivitySuggestions.length === 0 ? (
            <ProgressBar
              style={{ width: "70%", margin: "25px auto" }}
              animated
              variant="success"
              now={ActivityNow}
            />
          ) : null
        } */}
        <div style={{marginTop:"1.0rem"}}>
        <Input
          id={InputId}
          name="Text"
          disabled={
            ActivitySuggestions && ActivitySuggestions.length === 0
              ? true
              : false
          }
          Style={inputStyle}
          onChange={(e) => onChange(e, listName)}
          hint={placeholder}
          value={userInputActivity}
        />
        {listName === "ActivityCodes" ? suggestionsListComponentActivity : null}
        </div>
      </div>

      {listName === "ActivityCodes" && section === "activities" && BtnActive ? (
        <React.Fragment>
          <Button
            Style="enabledStyle"
            Value={BtnValue}
            onClick={(e) => addNewCode(e, listName, InputId)}
          />
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
}
export default ActivityCodeList10;
